import api from '@/modules/api.service';
import type { RelatorioAtividadeDto } from '../relatorios-atividades.types';

export async function salvarRelatorioUseCase(
  defensorId: number,
  defensoriaId: number,
  mes: string,
  ano: number,
  tipo: 'civil' | 'criminal',
  dados: any,
  status: 'rascunho' | 'pendente' | 'enviado' | 'aprovado' | 'reprovado' = 'rascunho',
  id?: number,
): Promise<RelatorioAtividadeDto> {
  try {
    if (id) {
      const response = await api.put(`/relatorios/atividades/${id}`, {
        defensorId,
        defensoriaId,
        mes,
        ano,
        tipo,
        status,
        dados,
      });
      return response.data;
    }

    const response = await api.post(`/relatorios/atividades`, {
      defensorId,
      defensoriaId,
      mes,
      ano,
      tipo,
      status,
      dados,
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar relatório:', error);
    throw error;
  }
}
